export type SelectOptionType = {value: number; label: string};

export const OPTIONS: Array<SelectOptionType> = [
    {value: 0, label: 'Send your prescription'},
    {value: 1, label: 'Pre order questions'},
    {value: 2, label: 'Edit your order'},
    {value: 3, label: 'Status update'},
    {value: 4, label: 'Shipping inquiries'},
    {value: 5, label: 'Prescription questions'},
    {value: 6, label: 'Billing inquiries'},
    {value: 7, label: 'Returns'},
    {value: 8, label: 'Itemized receipt request'},
    {value: 9, label: 'Home Try-On'},
    {value: 10, label: 'Other'},
];

export const CONTACTS_DISCOUNT_NUM = 30;
export const CONTACTS_DEFAULT_COUPON = 'contactnew30';
export const RETURNING_CUSTOMER_COUPON = 'contacts10';
